import { Http } from "../utils/http.js";
class Login extends Http {
  webLoginByCode(code) {
    let _this = this;
    return _this.request({
      url: "WebApi/Login/WebLoginByCode?code=" + code + "&state=1",
      method: "post"
    });
  }

  sendSMS(param) {
    let _this = this;
    return _this.request({
      url: "WebAPI/Login/SendSMS",
      method: "post",
      param:param
    });
  }

  appLogin(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Login/APPLogin",
      method: "post",
      param:param
    });
  }
}
export { Login };
